<title>{{ frequentTravellerAviosPage.htmlTitle }}</title>
<app-section [sections]="frequentTravellerAviosPage.sections"></app-section>
<app-api-reference-table-section
  class="countryTitleWithTable"
  [tableSections]="frequentTravellerAviosPage.tableSections"
  [testingYourBuildPage]="true"
  [isDefault]="false"
></app-api-reference-table-section>
